import { render } from "./List.vue?vue&type=template&id=511a5612&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=511a5612&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-511a5612"

export default script